export const getFileNameFromUrl = (url) => {
  if (!url) return null;
  try {
    const path = url.split("?")[0];
    return decodeURIComponent(path.substring(path.lastIndexOf("/") + 1));
  } catch {
    return null;
  }
};

export const downloadWithName = async (fileLink, fileName) => {
  if (!fileName) {
    window.open(fileLink, "_blank");
    return;
  }
  try {
    const res = await fetch(fileLink);
    if (!res.ok) throw new Error();
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  } catch {
    window.open(fileLink, "_blank");
  }
};

export const downloadFile = (fileDto) => {
    const link = document.createElement("a");

    link.href = fileDto.file;
    link.setAttribute("download", fileDto.fileName);
    link.setAttribute("target", "_self");
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
